import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/maydayContent";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || open ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-background-50"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-4 md:px-6 h-16">
        <a href="#home" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg w-5 h-5 flex items-center justify-center"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold text-foreground-950">五一爆料</span>
            <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">节日背后的真相</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 hover:bg-background-200/60 hover:text-primary-700 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#tougao"
            className="whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-foreground-800 transition-colors"
          >
            线索爆料
            <i className="ri-megaphone-line ml-1.5 text-sm w-4 h-4 inline-flex items-center justify-center"></i>
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 hover:bg-background-200/60 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl w-6 h-6 flex items-center justify-center`}></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-4 lg:hidden">
          <div className="grid grid-cols-2 gap-1 pt-3 sm:grid-cols-3">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-200/60"
              >
                {l.label}
              </a>
            ))}
          </div>
          <a
            href="#tougao"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            线索爆料
            <i className="ri-megaphone-line ml-1.5 text-sm w-4 h-4 inline-flex items-center justify-center"></i>
          </a>
        </nav>
      )}
    </header>
  );
}